<template>
  <div class="BgSection">
    <span @click="navigateToPage" v-if="sectionId">{{ sectionTitle }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
<script>
import moment from "moment";
export default {
  name: "bg-section",
  props: ["videoRef", "currentTime", "scrubberTimeChange", "data"],
  data() {
    return {
      startedAt: this.data.started_at,
      sectionTitle: "",
      sectionId: null,
    };
  },
  mounted() {
    this.checkForPage(this.currentTime);
  },
  watch: {
    currentTime: function (newTime) {
      this.checkForPage(newTime);
    },
  },
  methods: {
    navigateToPage() {
      this.$router.push({
        path: `/test/${this.$route.params.id}/page-insights?page=${this.sectionId}`,
      });
    },
    checkForPage(newTime) {
      const { sections } = this.data;
      const currentTime = moment(this.data.started_at).add(newTime, "seconds");
      const activeSection = sections.find((s) => {
        return currentTime.isBetween(s.timestamp_start, s.timestamp_end);
      });
      this.sectionTitle = activeSection ? activeSection.label.name : "";
      this.sectionId = activeSection ? activeSection.label.id : null;
    },
  },
};
</script>
